import React from 'react';
import { DropdownItemGroup } from '@atlaskit/dropdown-menu';
export var ToolbarDropdownItemSection = function ToolbarDropdownItemSection(_ref) {
  var children = _ref.children,
    hasSeparator = _ref.hasSeparator,
    title = _ref.title,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(DropdownItemGroup, {
    hasSeparator: hasSeparator,
    title: title,
    "data-toolbar-component": "menu-section",
    testId: testId
  }, children);
};